var map = {
	"./asset-hyperlink.json": "aTlh",
	"./blockquote.json": "e1n0",
	"./document.json": "80UV",
	"./embedded-asset-block.json": "2YEX",
	"./embedded-entry-block.json": "OTCR",
	"./embedded-entry-inline.json": "h+pT",
	"./embedded-resource-block.json": "7FjG",
	"./embedded-resource-inline.json": "4fuU",
	"./entry-hyperlink.json": "YAta",
	"./heading-1.json": "8yNx",
	"./heading-2.json": "nsp/",
	"./heading-3.json": "6JaB",
	"./heading-4.json": "3pr1",
	"./heading-5.json": "FdDT",
	"./heading-6.json": "CfWd",
	"./hr.json": "pCWc",
	"./hyperlink.json": "vMpm",
	"./list-item.json": "v2Nw",
	"./ordered-list.json": "wnwq",
	"./paragraph.json": "cOof",
	"./resource-hyperlink.json": "eQhN",
	"./table-cell.json": "y3Fm",
	"./table-header-cell.json": "Gnk/",
	"./table-row.json": "uslY",
	"./table.json": "2b3s",
	"./text.json": "T1LN",
	"./unordered-list.json": "kGdB"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "yncz";